
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IHelpInfo, IHelpParameter, Uri } from "@tylertech/tyler-api-types";

/**
 * HelpService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class HelpService {
    private readonly $apiService = inject(ApiService);
    
    GetHelpInfo(help: IHelpParameter): Promise<IHelpInfo> {
        return this.$apiService.sendAuth("IHelpService/GetHelpInfo", help);
    }
    GetModuleCode(moduleName: string): Promise<string> {
        return this.$apiService.sendAuth("IHelpService/GetModuleCode", moduleName);
    }
    GetUrl(help: IHelpParameter): Promise<Uri> {
        return this.$apiService.sendAuth("IHelpService/GetUrl", help);
    }
}
